import React, { useEffect } from 'react';
import { change, Field, formValueSelector } from "redux-form";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';

//Components
import CommonFormComponent from "../../CommonField/CommonFormComponent";
//Helper
import messages from "../../../locale/jsonMessages";

const TravelReason = () => {

    const dispatch = useDispatch()
    const selector = formValueSelector('ReservationMessage')
    const travelReasonSelector = formValueSelector("ContactHostForm");
    const travelReason = useSelector(state => selector(state, 'travelReason'))
    const travelReasonOptions = useSelector(state => travelReasonSelector(state, 'travelReason'));
    const { formatMessage } = useIntl();

    const options = [
        { label: formatMessage(messages.familyOuting), value: 'Family outing' },
        { label: formatMessage(messages.businessTrip), value: 'Business trip' },
        { label: formatMessage(messages.movingItems), value: 'Moving items' },
        { label: formatMessage(messages.tourismSightseeing), value: 'Tourism or sightseeing' },
        { label: formatMessage(messages.localCommute), value: 'Local commute' },
        { label: formatMessage(messages.others), value: 'Others' }
    ];
    useEffect(() => {
        if (!travelReason && options.length > 0) {
            dispatch(change('ReservationMessage', 'travelReason', travelReasonOptions ? travelReasonOptions : options[0].value))
        }
    }, [options, travelReason, travelReasonOptions])

    return (
        <Field
            name="travelReason"
            component={CommonFormComponent}
            labelText={formatMessage(messages.reasonForBooking)}
            inputClass='commonSelectField'
        >
            {options?.map((item, key) => {
                return (
                    <option key={key} value={item?.value}>{item?.label}</option>
                )
            })}
        </Field>
    )
}

export default TravelReason;
